(function () {
    'use strict';

    angular
        .module('app')
        .directive('jsTree', jsTree);

    jsTree.$inject = ['$log', '$timeout', '$filter'];

    function jsTree($log, $timeout, $filter) {
        // Usage:
        //     <jsTree></jsTree>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                data: "=?",
                selectedNode: "=?",
                onRename: "=?",
                onCreate: "=?",
                onDelete: "=?",
                control: "=?"
            }
        };
        return directive;

        function link(scope, element, attrs) {
            function contextMenu(node) {
                var items = {
                    renameItem: {
                        label: 'Rename',
                        _disabled: node.type == 1,
                        action: function () {
                            tree.edit(node, null, function () { });
                            $timeout(function () {
                                $(".jstree-rename-input").css("width", "auto");
                                $(".jstree-rename-input").on("keyup", function () {
                                    $timeout(function () {
                                        $(".jstree-rename-input").css("width", "auto");
                                    })
                                });
                            }, 1);
                        }
                    },
                    createItem: {
                        label: 'Create',
                        action: function () {
                            tree.open_node(node, function () {
                                scope.onCreate(node).then(function (data) {
                                    var newNode = { text: data.Name, data: data.Path, type: 2 };
                                    tree.create_node(node, newNode, "first", function (obj) {
                                        tree.edit(obj, null, function () {

                                        });
                                        $(".jstree-rename-input").css("width", "auto");
                                        $(".jstree-rename-input").on("keyup", function () {
                                            $timeout(function () {
                                                $(".jstree-rename-input").css("width", "auto");
                                            });
                                        });
                                    })
                                }, function (error) {
                                    console.log(error);
                                })
                            });
                            
                        }
                    }
                }
                return items;
            }

            $(element).jstree({
                core: {
                    data: scope.data,
                    check_callback: true,
                    multiple: false,
                    animation: true,
                    error: function (error) {
                        $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
                    },
                    worker: true,
                },
                plugins: ["contextmenu", "types", "unique"],
                contextmenu: {
                    items: contextMenu
                },
                types: {
                    1: {
                        icon: 'fa fa-hdd-o'
                    },
                    2: {
                        icon: 'fa fa-folder-o'
                    },
                    cloud: {
                        icon: 'glyphicon glyphicon-cloud'
                    }
                },
            });

            $(element).on('changed.jstree', function (e, data) {
                $timeout(function () {
                    var i, j, r = [];
                    for (i = 0, j = data.selected.length; i < j; i++) {
                        r.push(data.instance.get_node(data.selected[i]).data);
                    }
                    scope.selectedNode = r[0];
                });              
            }).on('rename_node.jstree', function (obj, obj2) {
                if (scope.onRename) {
                    scope.onRename(obj2).then(function (obj) {
                        tree.deselect_node(obj.node);
                    }, function (obj) {
                        tree.rename_node(obj.node, obj.old);
                    });
                }
            }).on('create_node.jstree', function (event, node, position) {
                var parent = tree.get_node(node.parent);

            });

            scope.internalControl = scope.control || {};
            scope.internalControl.navigateTo = function (path) {
                
                var parts = path.split("\\");
                parts = $filter("filter")(parts, "!", true);

                var i = 0;
                var id = parts[i];
                var node = tree.get_node(id.toUpperCase());

                var afterLoad = function () {
                    i++;              
                    if (i < parts.length) {
                        id = id + "\\" + parts[i];

                        node = tree.get_node(id.toUpperCase());
                        if (node) {
                            tree.load_node(node, function () {
                                tree.open_node(node);
                                if (i == parts.length - 1) {
                                    tree.select_node(node);
                                    var domEl = tree.get_node(node, true);
                                    var parent = $(element).parent();
                                    var times = 1;
                                    while ($(domEl).position().top > 300 && times < 20) {
                                        parent.scrollTop(parent.scrollTop() + 30);
                                        times++;
                                    }
                                }
                            });
                        }
                        
                    }
                    else {
                        $(element).off('after_open.jstree', afterLoad);
                        tree.select_node(node);
                    }
                                    
                }
                $(element).on('after_open.jstree', afterLoad);
                tree.load_node(node, function () {
                    tree.open_node(node);
                });
            }

            
            var tree = $.jstree.reference(element);
            tree.hide_dots();
        }
    }

})();